export enum FilterGroupType {
	Included = 1,
	Excluded = 2
}